<template lang="pug">
  input(type="text",
    :id="name",
    :name="name",
    :readonly="readonly",
    :disabled="disabled",
    :placeholder="placeholder",
    :required="required",
    :value="value",
    :maxdate="maxdate",
    :maxlength="maxlength_date",
    @input="$emit('input', $event.target.value)"
    )
</template>

<script>
import 'jquery-ui/ui/widgets/datepicker'
import 'jquery-ui/ui/i18n/datepicker-ja'
import 'jquery-ui/themes/base/datepicker.css'

export default {
  name: 'DatePicker',
  props: {
    id: {type: String, required: false, default: ''},
    name: {type: String, required: false, default: ''},
    value: {type: String, required: false, default: ''},
    placeholder: {type: String, required: false, default: ''},
    readonly: {type: Boolean, required: false, default: false},
    disabled: {type: Boolean, required: false, default: false},
    required: {type: Boolean, required: false, default: false},
    maxdate: {type: String, required: false, default: null},
    defaultDate: {type: String, required: false, default: null}
  },
  // watch: {
  //   value: function (newDate) {
  //     $(this.el).datepicker('setDate', newDate)
  //   }
  // },
  mounted: function () { // 要素を取得するためにcreatedにはしない
    const $date = $(this.$el).datepicker({
      changeYear: true, // 年のプルダウンを表示
      changeMonth: true, // 月のプルダウンを表示
      showButtonPanel: true, // 今日ボタンと閉じるボタンを表示
      onClose: this.onClose,
      maxDate: this.maxdate
    })
      .datepicker('setDate', this.value || this.defaultDate)
    this.$emit('input', $.datepicker.formatDate('yy/mm/dd', $date.datepicker('getDate')))
  },
  beforeDestroy: function () {
    $(this.$el).datepicker('hide').datepicker('destroy')
  },
  methods: {
    onClose: function (date) {
      this.$emit('input', date)
    }
  }
}
</script>

<!-- datepickerがscope外に埋め込まれるため、scopeは不要- -->
<style lang="scss">
@import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';

// mantis:0042026 bootstrap radioのラベルが2
/*.input-group*/ input.hasDatepicker,
/*.input-group*/ input.hasDatepicker:focus {
  position: relative;

  z-index: 900 !important; // popupが811
}

// 0042857: modalのz-index1050が計算に使われるようにした
.modal .form-group input.hasDatepicker,
.modal .form-group input.hasDatepicker:focus {
  position: static;
}

/* datepicker 独自スタイル */
.ui-datepicker {
  padding: 0;
  background-color: #fff;

  .ui-datepicker-header {
    border: none;
  }

  select.ui-datepicker-month,
  select.ui-datepicker-year {
    width: 40%;

    vertical-align: middle;
  }
  select.ui-datepicker-month {
    margin-left: .6em;
  }
  select.ui-datepicker-year {
    margin-right: .2em;
  }

  .ui-datepicker-next,
  .ui-datepicker-prev {
    cursor: pointer;
  }
  .ui-datepicker-prev-hover,
  .ui-datepicker-next-hover {
    top: 2px; // 動かさない
  }
  .ui-datepicker-prev-hover {
    left: 2px; // 動かさない
  }
  .ui-datepicker-next-hover {
    right: 2px; // 動かさない
  }

  td .ui-state-default {
    margin: 0;
    padding: .5em;

    background: none;
    border-color: transparent;
    text-align: center;
  }

  td .ui-state-highlight,
  // 今日
  td .ui-state-hover {
    color: $pagination-hover-color;
    background: $pagination-hover-bg;
    border-color: $pagination-border;
  }

  td .ui-state-active {
    // 選択日
    color: $pagination-active-color;
    background: $pagination-active-bg;
  }

  .ui-datepicker-buttonpane {
    .ui-datepicker-close {
      font-weight: normal;
    }
    .ui-datepicker-current {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/DatePicker.vue